import {
  selectFilteredAggregatedFeatures,
  selectFilteredFeatures,
} from "../selectors/resultMap";
import { useCallback, useMemo } from "react";

import { THEME } from "../constants";
import { useSelector } from "react-redux";

export const useGetGroupColor = () => {
  const focusedVarieties = useSelector(
    ({ resultMap }) => resultMap.focusedVarieties
  );

  const aggregatedFeatures = useSelector(selectFilteredAggregatedFeatures);
  const features = useSelector(selectFilteredFeatures);
  // Colorable entities: variety groups + individual plot ids (a focus entry can
  // be either — see FocusList's "plots" search on the PCA page).
  const colorable = useMemo(
    () =>
      new Set([
        ...aggregatedFeatures.map(({ group }) => group),
        ...features.map(({ displayId }) => displayId),
      ]),
    [aggregatedFeatures, features]
  );

  return useCallback(
    (gen) => {
      let index = focusedVarieties.indexOf(gen);
      // gen may be a variety group whose plot was focused individually by its
      // displayId (PCA). Resolve the color from that focused plot so the group
      // shows the same color everywhere (e.g. the plot rating modal header).
      if (index === -1) {
        const focusedPlot = features.find(
          ({ group, displayId }) =>
            group === gen && focusedVarieties.includes(displayId)
        );
        index = focusedPlot
          ? focusedVarieties.indexOf(focusedPlot.displayId)
          : -1;
      }

      if (index === -1) return "transparent";
      if (!colorable.has(gen)) return "lightgray"; // gray out when group is filtered

      return THEME.extendedPalette[index % THEME.extendedPalette.length];
    },
    [focusedVarieties, colorable, features]
  );
};
